import { Typography } from '@mui/material';
import {
  OnBoardingCompletedReportDetailsType,
  OnBoardingReportDetailsType,
} from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { ColumnType } from '../DataTable';
import {
  APPLICATION_STATUS,
  PAYMENT_STATUS,
  POA_APPLICATION_STATUS,
  PaymentMaster,
} from '../../utils/constant';
import { commonHeadersForSummaryReports } from './report-utils';
import { currencyConversion } from '../../utils/utilityFunctions';

export const reportData: {
  value: string;
  key: string;
  tableHeaders: ColumnType[];
}[] = [
  {
    value: 'onboardingSummary',
    key: ' Fund Wise Onboarding Summary',
    tableHeaders: commonHeadersForSummaryReports,
  },
  {
    value: 'onboardingDetails',
    key: 'Onboarding Details',
    tableHeaders: [
      {
        header: 'First Holder Name',
        label: 'firstHolderName',
        valueGetter: (row: OnBoardingReportDetailsType) => row.firstHolderName || 'NA',
      },
      {
        header: 'Application ID',
        label: 'applicationNumber',
        valueGetter: (row: OnBoardingReportDetailsType) => row.applicationNumber || 'NA',
      },
      {
        header: 'Mode of Holding',
        valueGetter: (row: OnBoardingReportDetailsType) => row.modeOfHolding || 'NA',
      },
      {
        header: 'Scheme',
        valueGetter: (row: OnBoardingReportDetailsType) => row.scheme || 'NA',
      },
      {
        header: 'Date of onboarding',
        label: 'createdAt',
        valueGetter: (row: OnBoardingReportDetailsType) => formatShortDate(row.createdAt) || 'NA',
      },
      {
        header: 'Commitment Amount',
        label: 'commitmentAmount',
        renderCell: (row: OnBoardingReportDetailsType) => (
          <Typography style={{ fontSize: 'inherit', maxWidth: 210 }}>
            {row.commitmentAmount || 'N/A'}
            <Typography style={{ fontSize: 12 }}>
              {currencyConversion(row.commitmentAmount, row?.plan?.currencyType) || ''}
            </Typography>
          </Typography>
        ),
      },
      // {
      //   header: 'Committed Value',
      //   valueGetter: (row: OnBoardingReportDetailsType) =>
      //     row.commitmentAmount
      //       ? row.commitmentAmount +
      //         ' ' +
      //         currencyConversion(row?.commitmentAmount, row?.plan?.currencyType)
      //       : 'NA',
      // },
      {
        header: 'First Holder Tax Id',
        valueGetter: (row: OnBoardingReportDetailsType) => row.firstHolderPAN || 'NA',
      },
      {
        header: 'Distributor Name',
        valueGetter: (row: OnBoardingReportDetailsType) => row.distributor || 'NA',
      },
      {
        header: 'Leegality Document Id',
        valueGetter: (row: OnBoardingReportDetailsType) => row.leegalityDocumentId || 'NA',
      },
      // {
      //   header: 'Folio No',
      //   valueGetter: (row: OnBoardingReportDetailsType) =>
      //     row.folio_no || row.xalt_folio_no || 'NA',
      // },
      {
        header: 'Status',
        valueGetter: ({ status }: OnBoardingReportDetailsType) =>
          APPLICATION_STATUS[status] || POA_APPLICATION_STATUS[status] || 'NA',
      },
      {
        header: 'Payment Mode',
        valueGetter: ({ paymentType }: OnBoardingReportDetailsType) =>
          PaymentMaster[paymentType || ''] || 'N/A',
      },
      {
        header: 'Payment Status',
        valueGetter: ({ paymentStatus }: OnBoardingReportDetailsType) =>
          PAYMENT_STATUS[paymentStatus || ''] || 'N/A',
      },
    ],
  },
  {
    value: 'distributorOnBoardingSummary',
    key: 'Distributor Wise Total Onboarding Summary',
    tableHeaders: commonHeadersForSummaryReports,
  },
  // {
  //   value: 'distributorOnBoardingDetail',
  //   key: 'Distributor wise onBoarding details',
  //   tableHeaders: [],
  // },
  {
    value: 'distributorCommitmentAmount',
    key: 'Distributor wise commitment amount report',
    tableHeaders: [
      {
        header: 'Investor Type',
        label: 'investorType',
      },
      {
        header: 'Completed',
        label: 'completed',
      },
      {
        header: 'Capital Commitment',
        label: 'commitmentAmount',
      },
      {
        header: 'Contribution Amount',
        label: 'contributionAmount',
      },
    ],
  },
  {
    value: 'onboardingCompletedDetails',
    key: 'Onboarding Completed Details',
    tableHeaders: [
      {
        header: 'Application ID',
        label: 'applicationNumber',
        valueGetter: (row: OnBoardingCompletedReportDetailsType) => row.applicationNumber || 'NA',
      },
      {
        header: 'First Holder Name',
        label: 'firstHolderName',
        valueGetter: (row: OnBoardingCompletedReportDetailsType) => row.firstHolderName || 'NA',
      },
      {
        header: 'Folio Number',
        valueGetter: (row: OnBoardingCompletedReportDetailsType) =>
          row.folio_no || row.xalt_folio_no || 'NA',
      },
      {
        header: 'Distributor Name',
        valueGetter: (row: OnBoardingCompletedReportDetailsType) => row.distributor || 'NA',
      },
      {
        header: 'First Holder Tax Id',
        valueGetter: (row: OnBoardingCompletedReportDetailsType) => row.firstHolderPAN || 'NA',
      },
      {
        header: 'Date of completion',
        label: 'updatedAt',
        valueGetter: (row: OnBoardingCompletedReportDetailsType) =>
          formatShortDate(row.updatedAt) || 'NA',
      },
      {
        header: 'Payment Mode',
        valueGetter: ({ paymentType }: OnBoardingCompletedReportDetailsType) =>
          PaymentMaster[paymentType || ''] || 'N/A',
      },
      {
        header: 'Payment Status',
        valueGetter: ({ paymentStatus }: OnBoardingCompletedReportDetailsType) =>
          PAYMENT_STATUS[paymentStatus || ''] || 'N/A',
      },
    ],
  },
];
